import type { TypedMyHotelSection } from './-MyHotelSection';
import RawMyHotelSection from './MyHotelSection.vue';
export * from './-MyHotelSection';
export const MyHotelSection = RawMyHotelSection as typeof TypedMyHotelSection;
